import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = {
    placeholders: { type: Array, default: [
      "Quelle SCPI pour un premier investissement ?",
      "Comparer Iroko Zen et Corum Origin...",
      "Comment investir 30 000 € en SCPI ?",
      "Quelle est la fiscalité des SCPI ?",
      "Les meilleures SCPI en 2025 ?"
    ]},
    assistantUrl: { type: String, default: "/assistant" },
    interval: { type: Number, default: 4000 }
  }

  connect() {
    this.currentIndex = 0
    this.isTyping = false
    this.startGhostText()
  }

  disconnect() {
    this.stopGhostText()
  }

  startGhostText() {
    if (this.placeholdersValue.length === 0) return

    this.updatePlaceholder()
    this.ghostTimer = setInterval(() => {
      if (!this.isTyping) {
        this.currentIndex = (this.currentIndex + 1) % this.placeholdersValue.length
        this.updatePlaceholder()
      }
    }, this.intervalValue)
  }

  stopGhostText() {
    if (this.ghostTimer) {
      clearInterval(this.ghostTimer)
      this.ghostTimer = null
    }
  }

  updatePlaceholder() {
    if (this.hasInputTarget) {
      this.inputTarget.placeholder = this.placeholdersValue[this.currentIndex]
    }
  }

  onFocus() {
    this.isTyping = true
  }

  onBlur() {
    if (this.inputTarget.value.trim() === "") {
      this.isTyping = false
    }
  }

  onInput() {
    this.isTyping = this.inputTarget.value.trim() !== ""
  }

  submit(event) {
    event.preventDefault()
    const query = this.inputTarget.value.trim()
    if (query === "") return

    const url = `${this.assistantUrlValue}?q=${encodeURIComponent(query)}`
    window.Turbo ? window.Turbo.visit(url) : (window.location.href = url)
  }
}
